import React from "react";
import ResultHistoryMobile from "./ResultHistoryMobile";
import RecentTicketMobile from "./RecentTicketMobile";
import { useRoulette } from "../../../store/roulette/RouletteContext";
import MobileDashboardDrawingRoulette from "./MobileDashboardDrawingRoulette";
import TabView from "../../lotto/TabView";

const Sale = ({appClass}) => {
    const { t } = useRoulette();

    const tabs = [t("labels:drawing.betting"), t("labels:drawing.result")];

    const children = [
        <RecentTicketMobile key="recent" />,
        <ResultHistoryMobile key="history" />,
    ];

    return (
        <div id="lotto90-mobile" className="rml-page">
            <div className="lotto1-36">
                <MobileDashboardDrawingRoulette appClass={appClass}/>
                <div className="tab-view border-all mt-2 num-pad-btn">
                    <TabView children={children} tabs={tabs} />
                </div>
            </div>
        </div>
    );
};

export default Sale;